import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IProgram } from '@/types/program';
import { request } from '@/utils';
import { reactive, ref, inject } from 'vue';
import _ from 'lodash';
import { ColorVariants } from '@/constants';
import { useRouter } from 'vue-router';
import { DialogProps } from '@/components/dialog.vue';

export interface Expose {
  participate(body: Record<string, any>): Promise<void>;
  closeDialog(dialogName?: 'success' | 'error' | undefined): void
}

interface Props {
  program: IProgram;
  successContent?: string;
  successDialogProps?: DialogProps;
  successDialogClassName?: string;
  errorDialogClassName?: string;
}


  const __default__ = {
    inheritAttrs: false
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    program: null,
    successContent: null,
    successDialogProps: null,
    successDialogClassName: { default: 'dialog-campaign dialog-campaign-participate-success' },
    errorDialogClassName: { default: 'dialog-campaign dialog-campaign-participate-error' }
  },
  setup(__props: any, { expose }) {

const props = __props as { program: IProgram, successContent?: string, successDialogProps?: DialogProps, successDialogClassName: string, errorDialogClassName: string }



const refreshPageData = (inject('refreshPageData') || _.noop) as Function;
const errMessage = ref('');
async function participate(body: Record<string, any>) {
  try {
    await request.post(`programs/${props.program.id}/participate`, body, { loading: { silent: true } });
    await refreshPageData();
    showDialog('success');
  } catch (e) {
    closeDialog();
    const status = _.get(e, 'status');
    const errorMsg = _.get(e, 'message');
    const code = _.get(e, 'code');
    // request.ts已经处理过这个code了
    if (status !== 401 && String(code) !== '40305') {
      errMessage.value = errorMsg;
      showDialog('error');
    }
    throw e;
  }
}

const router = useRouter();
function handleNavToRecordDetail() {
  closeDialog();
  router.push({ name: 'mine.programParticipationDetail', params: { id: props.program.participation_request_id } });
};

const dialog = reactive({
  success: false,
  error: false,
});

function closeDialog(dialogName?: keyof typeof dialog) {
  if (dialogName) {
    dialog[dialogName] = false;
  } else {
    _.forEach(dialog, (val, key) => {
      if (val) {
        dialog[key] = false;
      }
    });
  }
}

function showDialog(dialogName: keyof typeof dialog) {
  closeDialog();
  dialog[dialogName] = true;
}

expose({
  participate,
  closeDialog
});

return (_ctx: any,_cache: any) => {
  const _component_AppDialog = _resolveComponent("AppDialog")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_component_AppDialog, _mergeProps({
      visible: _unref(dialog).success,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_unref(dialog).success) = $event)),
      class: [__props.successDialogClassName],
      content: __props.successContent,
      btns: [
        { text: '확인', style: _unref(ColorVariants).primary, click: () => handleNavToRecordDetail() }
      ]
    }, __props.successDialogProps), null, 16, ["visible", "class", "content", "btns"]),
    _createVNode(_component_AppDialog, {
      visible: _unref(dialog).error,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_unref(dialog).error) = $event)),
      class: _normalizeClass([__props.errorDialogClassName]),
      content: errMessage.value,
      btns: [
        { text: 'OK', style: _unref(ColorVariants).primary, click: () => closeDialog() },
      ]
    }, null, 8, ["visible", "class", "content", "btns"])
  ]))
}
}

})